import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    // mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({ y: 0 }),
    routes: [{
            path: '/',
            redirect: '/main'
        },
        // {
        //     path: '/login',
        //     name: 'login',
        //     component: () =>
        //         import ("@/views/login/index.vue")
        // }, 
        {
            path: '/main',
            name: 'main',
            meta: {
                requireAuth: false, // 判断是否需要登录
            },
            component: () =>
                import ("@/views/main/index.vue")
        },
        // liss modify 2023-11-17 删除登录
        // {
        //     path: '/center',
        //     name: 'center',
        //     meta: {
        //         requireAuth: false, // 判断是否需要登录
        //     },
        //     component: () =>
        //         import ("@/views/center/index.vue")
        // }, 
        // end
        {
            path: '/search',
            name: 'search',
            meta: {
                requireAuth: false, // 判断是否需要登录
            },
            component: () =>
                import ("@/views/search/index.vue")
        }, {
            path: '/database',
            name: 'database',
            meta: {
                requireAuth: false, // 判断是否需要登录
            },
            component: () =>
                import ("@/views/database/index.vue")
        }, {
            path: '/item',
            name: 'item',
            meta: {
                requireAuth: false, // 判断是否需要登录
            },
            component: () =>
                import ("@/views/book/index.vue")
        }, {
            path: '/404',
            component: () =>
                import ('@/views/error-page/404'),
            hidden: true
        }, { path: '*', redirect: '/404', hidden: true }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js